
import { Employee } from '@/types';

// Mock Employees
export const employees: Employee[] = [
  {
    id: 'emp-1',
    userId: 'user-4',
    employeeId: 'MDCS61',
    manNumber: 'MDCS61',
    nrc: '448167/67/1',
    firstName: 'LUMBWE',
    lastName: 'KALIFUNGWA',
    otherName: '',
    email: 'lumbwe@example.com',
    phone: '+260973000000',
    cellNumber: '+260973000000',
    position: 'DISTRICT PLANNING OFFICER',
    jobTitle: 'DISTRICT PLANNING OFFICER',
    department: 'PLANNING',
    division: 'DIV I',
    joinDate: '2022-07-11',
    engagementDate: '2022-07-11',
    dateOfBirth: '1990-01-01',
    gender: 'male',
    socialSecurityNo: '314135453',
    status: 'active',
    basicSalary: 9656.20,
    basicPay: 9656.20,
    bankName: 'ZANACO',
    bankAccount: '1224726100167',
    bankBranch: '',
    taxId: '1009482811',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: 'LGSS 5',
    advanceBF: 0,
    leaveDaysPerMonth: 3.5,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-2',
    userId: 'user-5',
    employeeId: 'MDCS60',
    manNumber: 'MDCS60',
    nrc: '759220/11/1',
    firstName: 'EDGAR',
    lastName: 'MULWANDA',
    otherName: 'C',
    email: 'edgar@example.com',
    phone: '+260973000001',
    cellNumber: '+260973000001',
    position: 'COUNCIL SECRETARY',
    jobTitle: 'COUNCIL SECRETARY',
    department: 'INSTITUTION MANAGEMENT',
    division: 'DIV I',
    joinDate: '2004-09-29',
    engagementDate: '2004-09-29',
    dateOfBirth: '1980-08-21',
    gender: 'male',
    socialSecurityNo: '108332526',
    status: 'active',
    basicSalary: 10827.04,
    basicPay: 10827.04,
    bankName: 'STANBIC',
    bankAccount: '0121006578401',
    bankBranch: 'ARCADES BRANCH',
    taxId: '1000336650',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: '3',
    advanceBF: 0,
    leaveDaysPerMonth: 4,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-3',
    userId: 'user-6',
    employeeId: 'MDCS58',
    manNumber: 'MDCS58',
    nrc: '334301/33/1',
    firstName: 'TERRIOH',
    lastName: 'CHUNGU',
    otherName: 'MWAPE',
    email: 'terrioh@example.com',
    phone: '+260973000002',
    cellNumber: '+260973000002',
    position: 'COUNCIL CHAIRPERSON',
    jobTitle: 'COUNCIL CHAIRPERSON',
    department: 'INSTITUTION MANAGEMENT',
    division: 'DIV I',
    joinDate: '2021-09-16',
    engagementDate: '2021-09-16',
    dateOfBirth: '1990-09-09',
    gender: 'male',
    socialSecurityNo: '306549577',
    status: 'active',
    basicSalary: 11805.00,
    basicPay: 11805.00,
    bankName: 'FNB',
    bankAccount: '62935207127',
    bankBranch: 'Industrial Area',
    taxId: '1001360856',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: 'F03',
    advanceBF: 0,
    leaveDaysPerMonth: 3.5,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-4',
    userId: 'user-7',
    employeeId: 'MDCS20',
    manNumber: 'MDCS20',
    nrc: '155299/35/1',
    firstName: 'MATHEWS',
    lastName: 'MULENGA',
    otherName: 'H',
    email: 'mathews@example.com',
    phone: '+260979293597',
    cellNumber: '+260979293597',
    position: 'COUNCIL TREASURER',
    jobTitle: 'COUNCIL TREASURER',
    department: 'FINANCE',
    division: 'DIV I',
    joinDate: '2008-01-02',
    engagementDate: '2008-01-02',
    dateOfBirth: '1984-07-20',
    gender: 'male',
    socialSecurityNo: '710952293',
    status: 'active',
    basicSalary: 9392.70,
    basicPay: 9392.70,
    bankName: 'INDO',
    bankAccount: '0241020003352',
    bankBranch: 'MANSA BRANCH',
    taxId: '1003156623',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: '6',
    advanceBF: 0,
    leaveDaysPerMonth: 4,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-5',
    userId: 'user-8',
    employeeId: 'MDCS62',
    manNumber: 'MDCS62',
    nrc: '435746/67/1',
    firstName: 'JESSY',
    lastName: 'NAMUKONDA',
    otherName: '',
    email: 'jessy@example.com',
    phone: '+260973000004',
    cellNumber: '+260973000004',
    position: 'SOCIO ECONOMIC PLANNER',
    jobTitle: 'SOCIO ECONOMIC PLANNER',
    department: 'PLANNING',
    division: 'DIV I',
    joinDate: '2022-11-23',
    engagementDate: '2022-11-23',
    dateOfBirth: '1990-03-21',
    gender: 'female',
    socialSecurityNo: '526458100',
    status: 'active',
    basicSalary: 7235.38,
    basicPay: 7235.38,
    bankName: 'ZANACO',
    bankAccount: '1248452100308',
    bankBranch: 'KITWE-MUKUBA MALL',
    taxId: '2659053425',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: '7',
    advanceBF: 0,
    leaveDaysPerMonth: 3,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-6',
    userId: 'user-9',
    employeeId: 'MDCS45',
    manNumber: 'MDCS45',
    nrc: '259622/63/1',
    firstName: 'LEWIS',
    lastName: 'KUNDA',
    otherName: '',
    email: 'lewis@example.com',
    phone: '+260978152647',
    cellNumber: '+260978152647',
    position: 'TOWN PLANNER',
    jobTitle: 'TOWN PLANNER',
    department: 'PLANNING',
    division: 'DIV I',
    joinDate: '2020-02-03',
    engagementDate: '2020-02-03',
    dateOfBirth: '1994-04-03',
    gender: 'male',
    socialSecurityNo: '522695474',
    status: 'active',
    basicSalary: 7235.38,
    basicPay: 7235.38,
    bankName: 'INDO',
    bankAccount: '0241020003837',
    bankBranch: 'MANSA BRANCH',
    taxId: '2899892658',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: '7',
    advanceBF: 0,
    leaveDaysPerMonth: 3.5,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-7',
    userId: 'user-10',
    employeeId: 'MDCS36',
    manNumber: 'MDCS36',
    nrc: '442902/67/1',
    firstName: 'ARETHA',
    lastName: 'CHISENGA',
    otherName: 'MUPETA',
    email: 'aretha@example.com',
    phone: '+260973228196',
    cellNumber: '+260973228196',
    position: 'PROCUREMENT',
    jobTitle: 'PROCUREMENT',
    department: 'INSTITUTION MANAGEMENT',
    division: 'DIV I',
    joinDate: '2014-01-09',
    engagementDate: '2014-01-09',
    dateOfBirth: '1989-09-05',
    gender: 'female',
    socialSecurityNo: '108342614',
    status: 'active',
    basicSalary: 8227.38,
    basicPay: 8227.38,
    bankName: 'INDO',
    bankAccount: '0241020003267',
    bankBranch: 'MANSA BRANCH',
    taxId: '1006016352',
    unionType: 'ZALAAMU',
    contributionType: 'NAPSA',
    salaryScale: '7',
    advanceBF: 0,
    leaveDaysPerMonth: 3.5,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-8',
    userId: 'user-11',
    employeeId: 'MDCS19',
    manNumber: 'MDCS19',
    nrc: '319647/43/1',
    firstName: 'KHONDWELANI',
    lastName: 'TEMBO',
    otherName: '',
    email: 'khondwelani@example.com',
    phone: '+260973141804',
    cellNumber: '+260973141804',
    position: 'WATER CO-ORDINATOR',
    jobTitle: 'WATER CO-ORDINATOR',
    department: 'WORKS',
    division: 'DIV I',
    joinDate: '2017-05-22',
    engagementDate: '2017-05-22',
    dateOfBirth: '1992-05-13',
    gender: 'male',
    socialSecurityNo: '407435995',
    status: 'on_leave',  // Changed to on_leave for chart demonstration
    basicSalary: 7731.38,
    basicPay: 7731.38,
    bankName: 'ZANACO',
    bankAccount: '5519967100120',
    bankBranch: 'ZANACO',
    taxId: '1006832985',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: '7',
    advanceBF: 0,
    leaveDaysPerMonth: 3.5,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-9',
    userId: 'user-12',
    employeeId: 'MDCS54',
    manNumber: 'MDCS54',
    nrc: '336855/64/1',
    firstName: 'NATASHA',
    lastName: 'MWILA',
    otherName: '',
    email: 'natasha@example.com',
    phone: '+260974469550',
    cellNumber: '+260960363103',
    position: 'SENIOR BUILDING INSPECTOR',
    jobTitle: 'SENIOR BUILDING INSPECTOR',
    department: 'WORKS',
    division: 'DIV I',
    joinDate: '2020-09-16',
    engagementDate: '2020-09-16',
    dateOfBirth: '1995-10-22',
    gender: 'female',
    socialSecurityNo: '423390248',
    status: 'inactive',  // Changed to inactive for chart demonstration
    basicSalary: 5834.00,
    basicPay: 5834.00,
    bankName: 'INDO',
    bankAccount: '0321010000992',
    bankBranch: 'MUNGWI',
    taxId: '1012406612',
    unionType: '',
    contributionType: 'NAPSA',
    salaryScale: '7',
    advanceBF: 0,
    leaveDaysPerMonth: 3,
    mlifeContributionPercentage: 0.4
  },
  {
    id: 'emp-10',
    userId: 'user-13',
    employeeId: 'MDCS32',
    manNumber: 'MDCS32',
    nrc: '350123/61/1',
    firstName: 'MAILESI',
    lastName: 'MOYO',
    otherName: '',
    email: 'mailesi@example.com',
    phone: '+260977378790',
    cellNumber: '+260977378790',
    position: 'ADMINISTRATIVE OFFICER',
    jobTitle: 'ADMINISTRATIVE OFFICER',
    department: 'ADMINISTRATION',
    division: 'DIV II',
    joinDate: '2017-08-17',
    engagementDate: '2017-08-17',
    dateOfBirth: '1982-10-02',
    gender: 'female',
    socialSecurityNo: '519291748',
    status: 'active',
    basicSalary: 6035.68,
    basicPay: 6035.68,
    bankName: 'ZANACO',
    bankAccount: '5468862100149',
    bankBranch: 'ZANACO',
    taxId: '1006652710',
    unionType: 'ZALAAMU',
    contributionType: 'NAPSA',
    salaryScale: '10',
    advanceBF: 0,
    leaveDaysPerMonth: 3,
    mlifeContributionPercentage: 0.4
  }
];
